import { styled, Button } from "@mui/material";
import { FlexBox } from "@/components/baseComponents/FlexBox";

export const StyledContainer = styled(FlexBox)(({ theme }) => ({
  gap: theme.spacing(3),
  alignItems: "center",
}));

export const StyledMobileButton = styled(Button)(({ theme }) => ({
  minWidth: "auto",
  padding: theme.spacing(0.5),
  backgroundColor: "transparent",
  color: theme.palette.primary.contrastText,
  gap: theme.spacing(0.5),
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  },
}));

export const StyledLogoutButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.text.primary,
  padding: theme.spacing(1, 2),

  "&:hover": {
    backgroundColor: theme.palette.grey[400],
  },
}));

export const StyledLoginButton = styled(StyledLogoutButton)();
